import ProductModal from './vue/components/ProductModal.vue';

// Vue app for feedback and share popup
const productModalApp = new Vue({
  el: '#product-modal',
  components: {
    ProductModal,
  },
  render: h =>
    h(ProductModal, {
      ref: 'modal',
    }),
});

async function fillModal(productID) {
  const productModal = productModalApp.$refs.modal;
  productModal.reset();
  productModal.openModal();
  try {
    const response = await fetch(`/product_info/${productID}/`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    if (response.status === 404) {
      return productModal.setNotFound();
    }
    const product = await response.json();
    productModal.setProduct(product);
  } catch (err) {
    console.error('err', err);
  }
}

function closeProductModal() {
  const productModal = productModalApp.$refs.modal;
  productModal.closeModal();
}
function isProductModalOpen() {
  const productModal = productModalApp.$refs.modal;
  return productModal.isOpen();
}

export { fillModal, closeProductModal, isProductModalOpen };
